import { InterpolationPrimitive } from '@emotion/serialize'
import { useDirectiveFormContext } from 'components/directive/directiveFormLayout/DirectiveFormLayout'
import { Fieldset } from 'components/fieldset/Fieldset'
import { FormFieldset } from 'components/FormButton'
import { FieldValues, Path, RegisterOptions, UseFormReturn } from 'react-hook-form'
import { useFieldValidation } from 'utils/i18n/useFieldValidation'

export function TextField<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>
>(props: {
  form: UseFormReturn<TFieldValues>
  name: TName
  label: string
  area?: boolean
  type?: 'text' | 'number' | 'email'
  register?: RegisterOptions<TFieldValues, TName>
  noSpan?: boolean
  optional?: boolean
  span?: number
  info?: string
  fieldSetCss?: InterpolationPrimitive
  disabled?: boolean
}) {
  const { isReadOnly } = useDirectiveFormContext()
  const validation = useFieldValidation()
  const common = props.form.register(props.name, {
    ...validation.required(!props.optional),
    ...props.register,
  })
  const type = props.area ? 'textarea' : props.type ?? 'text'
  const span = props.noSpan ? undefined : props.span ?? 2

  return (
    <FormFieldset form={props.form}>
      <Fieldset
        css={[{ gridColumnEnd: span != null ? `span ${span}` : undefined }, props.fieldSetCss]}
        disabled={isReadOnly || props.disabled}
        info={props.info}
      >
        {type === 'textarea' ? (
          <textarea css={{ resize: 'vertical', minHeight: 160 }} placeholder="&nbsp;" {...common} />
        ) : (
          <input type={type} placeholder="&nbsp;" {...common} />
        )}
        <label>{props.label}</label>
      </Fieldset>
    </FormFieldset>
  )
}
